import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { resetPassword } from "./api";
import PasswordField from "../Components/PasswordField";
import { Link } from "react-router-dom";
import Header from "../Components/header";
import Footer from "../Components/footer";
import { use } from "react";
import { Validation } from "../Components/RegistrationForm";

const ResetPassword = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const [password, setPassword] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordChanged, setPasswordChanged] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isValidLength, setIsValidLength] = useState(false);
  const [isValidUpperCase, setIsValidUpperCase] = useState(false);
  const [isValidLowerCase, setIsValidLowerCase] = useState(false);
  const [isValidNumber, setIsValidNumber] = useState(false);
  const [isValidSpecialCharacter, setIsValidSpecialCharacter] = useState(false);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Le password non coincidono");
      return;
    }

    try {
      const response = await resetPassword(token, password);

      console.log("RESPONSE", response);
      if (response.status === 401) {
        console.log("Invalid token");

        setError("Error resetting password. Invalid token");

        return;
      }
      setMessage("Password reset successful");
      setPasswordChanged(true);
    } catch (error) {
      console.log(error.message);
      //setError("Error resetting password");
      setError(error.message);
    }
  };

  const handlePassword = (value) => {
    setIsValidLength(value.length >= 8);

    setIsValidUpperCase(/^(?=.*[A-Z]).*$/.test(value));
    //console.log("Maiuscola: ", isValidUpperCase);
    setIsValidLowerCase(/^(?=.*[a-z]).*$/.test(value));
    //console.log("Minuscola: ", isValidLowerCase);
    setIsValidNumber(/^(?=.*\d).*$/.test(value));
    //console.log("Numero: ", isValidNumber);
    setIsValidSpecialCharacter(/^(?=.*[!@#$%^&.*]).*$/.test(value));
    //console.log("Carattere speciale:", isValidSpecialCharacter);

    const isValidPassword =
      isValidLength &&
      isValidUpperCase &&
      isValidLowerCase &&
      isValidNumber &&
      isValidSpecialCharacter;
    console.log("La password è valida:", isValidPassword);

    setPassword(value);
  };

  const [passwordSelectedRegistration, setPasswordSelectedRegistration] =
    useState(false);

  const [isPasswordHidden, setHidePassword] = useState(true);

  const [
    confirmPasswordSelectedRegistration,
    setConfirmPasswordSelectedRegistration,
  ] = useState(false);

  if (passwordChanged) {
    return (
      <div>
        <Header />
        <div className="grid w-full place-items-center bg-gray-100">
          <div className="w-full h-full">
            <div className="mt-20 sm:mt-0 flex flex-col justify-center items-center h-[30rem] sm:h-[35rem]">
              <div className="p-8 -mt-10 rounded-lg shadow-md w-full max-w-md bg-white">
                <h1 className="text-3xl font-bold text-gray-600 mb-4">
                  Password Reset Successful
                </h1>
                <p className="text-gray-600 mb-4">
                  La tua password è stata reimpostata con successo. Ora puoi
                  accedere con la tua nuova password.
                </p>
                <Link
                  to="/login"
                  className="p-3 rounded bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline w-full"
                >
                  Go to Login
                </Link>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
  return (
    //GIUSTO
    <div>
      <Header />

      <div className="grid w-full place-items-center bg-gray-100">
        <div className="w-full h-full">
          <div className="mt-20 sm:mt-0 flex flex-col justify-center items-center h-[30rem] sm:h-[35rem]">
            <form
              onSubmit={handlePasswordReset}
              className="p-8 -mt-10 rounded-lg shadow-md w-full max-w-md bg-white"
            >
              <h1 className="text-3xl font-bold text-gray-600">
                Reset Password
              </h1>

              <PasswordField
                id="password"
                value={password}
                onChange={(e) => handlePassword(e.target.value)}
                onFocus={() => setPasswordSelectedRegistration(true)}
                onBlur={() => setPasswordSelectedRegistration(false)}
                selected={passwordSelectedRegistration}
                isPasswordHidden={isPasswordHidden}
                togglePasswordVisibility={() =>
                  setHidePassword(!isPasswordHidden)
                }
                label={"Password"}
              />
              <div
                className={`transition-all duration-[600ms] ease-in-out bg-white ${
                  passwordSelectedRegistration ? "max-h-40" : "max-h-0"
                } relative overflow-hidden`}
              >
                <Validation
                  password={password}
                  isValidLength={isValidLength}
                  isValidUpperCase={isValidUpperCase}
                  isValidLowerCase={isValidLowerCase}
                  isValidNumber={isValidNumber}
                  isValidSpecialCharacter={isValidSpecialCharacter}
                />
              </div>

              <PasswordField
                id="confirm_password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onFocus={() => setConfirmPasswordSelectedRegistration(true)}
                onBlur={() => setConfirmPasswordSelectedRegistration(false)}
                selected={confirmPasswordSelectedRegistration}
                isPasswordHidden={isPasswordHidden}
                togglePasswordVisibility={() =>
                  setHidePassword(!isPasswordHidden)
                }
                label={"Conferma Password"}
              />

              {message && <p className="text-green-500">{message}</p>}
              {error && <p className="text-red-500">{error}</p>}
              <button
                type="submit"
                className="mt-5 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
              >
                Reset Password
              </button>
              <Link
                to="/login"
                className="mt-10 text-blue-600 hover:underline  "
              >
                Torna al Login
              </Link>
            </form>
            {message && <p>{message}</p>}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ResetPassword;
